export enum KeyMap {
  tab = 9,
  enter = 13,
  space = 32,
  leftArrow = 37,
  upArrow = 38,
  rightArrow = 39,
  downArrow = 40,
  one = 49,
  numPadOne = 97,
  two = 50,
  numPadTwo = 98,
  three = 51,
  numPadThree = 99,
  four = 52,
  numPadFour = 100,
  five = 53,
  numPadFive = 101,
  six = 54,
  numPadSix = 102,
  seven = 55,
  numPadSeven = 103,
  eight = 56,
  numPadEight = 104,
  nine = 57,
  numPadNine = 105,
  fSlash = 191,
  numPadFSlash = 111,
  period = 190,
  numPadPeriod = 110,
  numPadPlus = 107,
  equals = 187,
  minus = 189,
  numPadMinus = 109,
  letterT = 84,
  ctrl = 17,
  numPadAsterisk = 106
}
